import { useNavigation } from "@react-navigation/native";
import React, { useState, useEffect, useCallback } from "react";
import {
  StyleSheet,
  View,
  TextInput,
  Pressable,
  ScrollView,
} from "react-native";
import Text from "@components/CustomText";
import Image from "@components/common/Image";
import color from "@constants/color";
import { normalize } from "@constants/metrics";
import { actions as snackbarActions } from "@reducers/snackbarReducer";
import { useDispatch } from "react-redux";
import { getPollFormItems, submitPollFormResponses } from "../../services/api";
import suffleArray from "../../utils/suffleArray";

import BackButton from "@components/BackButton";
const PollFormScreen = ({ route = {} }) => {
  const { params = {} } = route;
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const [pollFormItems, setPollFormItems] = useState([]);
  const [submission, setSubmission] = useState({});
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    async function fetchPollFormItems() {
      try {
        const { pollFormId = 1 } = params;
        const response = pollFormId && (await getPollFormItems(pollFormId));
        setPollFormItems(response.data || []);
      } catch (error) {
        console.log(error);
      }
    }
    fetchPollFormItems();
  }, []);

  const setSubmissions = ({ poll_id, answer_id, subjective_answer }) => {
    let lSubmission = JSON.parse(JSON.stringify(submission));
    lSubmission[poll_id] = {
      pollId: poll_id,
      answerId: answer_id,
      subjectiveAnswer: subjective_answer && subjective_answer.trim(),
    };

    const valid =
      itemsData().length === Object.values(lSubmission).length &&
      Object.values(lSubmission).filter(
        (item) => !!item.answerId || !!item.subjectiveAnswer,
      ).length > 0;

    setSubmission(lSubmission);
    setDisabled(!valid);
  };

  const pollFormData = () => {
    if (
      pollFormItems &&
      Array.isArray(pollFormItems) &&
      pollFormItems.length > 0
    ) {
      const {
        form_id,
        form_name,
        cl_title,
        bg_img,
        bg_img_height,
        bg_img_width,
        success_msg,
        recurring_submissions,
        randomize,
      } = pollFormItems[0] || {};
      return {
        id: form_id,
        name: form_name,
        title: cl_title,
        bgImg: bg_img,
        bgImgHeight: bg_img_height,
        bgImgWidth: bg_img_width,
        successMsg: success_msg || "Success",
        recurringSubmissions: recurring_submissions || true,
        randomize: randomize || false,
      };
    }
    return null;
  };

  const formData = pollFormData();

  const itemsData = () => {
    const items =
      pollFormItems && Array.isArray(pollFormItems) && pollFormItems.length > 0
        ? pollFormItems
        : [];
    if (formData?.randomize) {
      return suffleArray(items);
    }
    return items;
  };

  const saveSubmissions = async () => {
    const data = Object.values(submission);
    try {
      const response = await submitPollFormResponses({ data });
      if (response) {
        navigation.goBack();
        const payload = {
          shouldShow: true,
          message: formData.successMsg,
          position: "bottom",
          bottom: 0,
          autoHidingTime: 3000,
          autoHide: true,
        };
        dispatch(snackbarActions.showSnackbar(payload));
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <View style={styles.header}>
        <BackButton onPress={navigation.goBack} />
        <Text style={styles.headerTxt}>
          {decodeURIComponent(formData?.title || "").replace(/\+/g, " ")}
        </Text>
      </View>
      {formData?.bgImg && (
        <Image
          source={{ uri: formData?.bgImg }}
          style={{ height: formData?.bgImgHeight, width: "100%" }}
          resizeMode={Image.resizeMode.cover}
        />
      )}
      <ScrollView
        contentContainerStyle={{ backgroundColor: color.white, flex: 1 }}
      >
        {itemsData().map((poll, idx) => {
          if (poll.type === "SUBJECTIVE_QUESTION") {
            return (
              <View key={idx} style={{ margin: 10 }}>
                {poll?.header ? (
                  <Text variant="body_text_2">{poll.header}</Text>
                ) : null}
                {poll?.question ? (
                  <Text variant="body_text_2">{poll.question}</Text>
                ) : null}
                <TextInput
                  placeholder="यहाँ कुछ लिखें..."
                  style={styles.subjectiveTxtInput}
                  onChangeText={(text) =>
                    setSubmissions({
                      poll_id: poll.poll_id,
                      answer_id: null,
                      subjective_answer: text,
                    })
                  }
                  numberOfLines={15}
                  maxLength={500}
                  multiline={true}
                />
                <Text style={styles.answerCount}>{`${
                  submission[poll.poll_id]?.subjectiveAnswer.length || 0
                } / 500`}</Text>
              </View>
            );
          }
          return null;
        })}
        <Pressable
          style={[
            styles.submitBtnTxt,
            {
              backgroundColor: disabled ? "darkgray" : color.primary,
            },
          ]}
          disabled={disabled}
          onPress={() => saveSubmissions()}
        >
          <Text variant="subtitle_16" style={{ color: color.white }}>
            {"सबमिट करें"}
          </Text>
        </Pressable>
      </ScrollView>
    </>
  );
};

export default PollFormScreen;

const styles = StyleSheet.create({
  header: {
    backgroundColor: color.white,
    borderBottomColor: "rgba(0,0,0,0.1)",
    borderBottomWidth: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  headerTxt: {
    fontWeight: "bold",
    fontSize: 16,
    paddingVertical: normalize(20),
    paddingLeft: normalize(15),
  },
  subjectiveTxtInput: {
    padding: normalize(10),
    marginTop: normalize(3),
    borderWidth: 1,
    borderColor: "lightgray",
    borderRadius: normalize(4),
    textAlignVertical: "top",
  },
  submitBtnTxt: {
    margin: normalize(10),
    padding: normalize(15),
    alignItems: "center",
    justifyContent: "center",
    borderRadius: normalize(4),
  },
  answerCount: {
    marginLeft: "auto",
    marginTop: normalize(4),
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.36)",
  },
});
